import React, {
useState,
useEffect,
useRef,
useCallback
} from "react";
import "./ExamPage.css";
import styles from "./ExamPageThinkingSkills.module.css";

import OcThinkingSkillsReview from "./OcThinkingSkillsReview";

/* ============================================================
 MAIN COMPONENT
============================================================ */
export default function ExamPageOcThinkingSkills({
  mode: parentMode,   // 🔥 ADD THIS
  onExamStart,
  onExamFinish,
  onBackToDashboard
}) {
const studentId = sessionStorage.getItem("student_id");
const [reviewLoading, setReviewLoading] = useState(false);
console.log("🔥 parentMode (child):", parentMode);
const [attempts, setAttempts] = useState([]);

const loadAttempts = useCallback(async () => {
  try {
    const isHomework = parentMode?.includes("homework");

    console.log("📌 parentMode:", parentMode);
    console.log("📌 isHomework:", isHomework);

    const endpoint = isHomework
      ? "/api/student/homework-attempts/oc-thinking-skills"
      : "/api/student/exam-attempts/oc-thinking-skills";

    console.log("🌐 Attempts endpoint:", endpoint);

    console.log("📡 Fetching attempts from:", endpoint);
    console.log("ATTEMPT OBJECT", attempts[0]);

    const res = await fetch(
      `${API_BASE}${endpoint}?student_id=${studentId}`
    );

    if (!res.ok) {
      console.warn("⚠️ Failed to load attempts");
      return;
    }

    const data = await res.json();

    console.log("📅 attempts:", data);

    setAttempts(data);

  } catch (err) {
    console.error("❌ loadAttempts error:", err);
  }
}, [studentId, parentMode]); 
const isPopNavigationRef = useRef(false);
const formatExplanation = (text) => {
  if (!text) return "";

  return text
    // Bold headings + spacing
    .replace(
      /\*\*(.*?)\*\*/g,
      "<strong style='display:block; margin-top:10px;'>$1</strong>"
    )
    // Paragraph spacing
    .replace(/\n\n/g, "<br/><br/>")
    // Line breaks
    .replace(/\n/g, "<br/>");
};
 
const hasStartedRef = useRef(false);
const IMAGE_BASE =
"https://storage.googleapis.com/exammoduleimages/";
console.log("🧠 ExamPageOcThinkingSkills MOUNTED");
const [explanation, setExplanation] = useState(null);
const [loadingExplanation, setLoadingExplanation] = useState(false);
 




const hasSubmittedRef = useRef(false);
const normalizeOption = (value) => {
  if (!value) return null;

  // already normalized object
  if (typeof value === "object" && value) {
  const raw = value.src || value.content || "";

  const looksLikeImage =
    typeof raw === "string" &&
    (
      raw.includes("storage.googleapis.com") ||
      /^https?:\/\//i.test(raw) ||
      /\.(png|jpg|jpeg|webp)(\?.*)?$/i.test(raw)
    );

  if (looksLikeImage) {
    return {
      type: "image",
      src: raw.trim()
    };
  }

  return {
    type: "text",
    content: String(raw).trim()
  };
}

  const str =
    typeof value === "string"
      ? value.trim()
      : JSON.stringify(value).trim();

  const isImage =
    str.includes("storage.googleapis.com") ||
    /^https?:\/\//i.test(str) ||
    /\.(png|jpg|jpeg|webp)(\?.*)?$/i.test(str);

  if (isImage) {
    return {
      type: "image",
      src: str.replace(/^"|"$/g, "")
    };
  }

  return {
    type: "text",
    content: str.replace(/^"|"$/g, "")
  };
};
const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:3000";


if (!API_BASE) {
  throw new Error("❌ REACT_APP_API_URL is not defined");
}
const [examAttemptId, setExamAttemptId] = useState(null);
const handleGenerateExplanation = async () => {
  if (!currentQ) return;

  setLoadingExplanation(true);
  setExplanation(null);

  try {
    const response = await fetch(
      `${API_BASE}/api/ai/explain-question-TS`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          question: currentQ.blocks,
          options: currentQ.options,
          correct_answer: currentQ.correct_answer
        })
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate explanation");
    }

    const data = await response.json();

    setExplanation(data.explanation || "No explanation returned.");

  } catch (err) {
    console.error("Explanation error:", err);
    setExplanation("Failed to generate explanation.");
  } finally {
    setLoadingExplanation(false);
  }
};
 const handleViewExamDetails = () => {
  setReviewLoading(true);
  setQuestions([]);
  setCurrentIndex(0);
  setVisited({});
  setAnswers({});
  setMode("review");
};




/**
 * mode:
 * - loading → deciding what to show
 * - exam    → active attempt
 * - report  → completed attempt
 */
const [mode, setMode] = useState("loading");
const isReview = mode === "review";



// ---------------- EXAM STATE ----------------
const [questions, setQuestions] = useState([]);




const [currentIndex, setCurrentIndex] = useState(0);
const [answers, setAnswers] = useState({});
const [visited, setVisited] = useState({});
const [timeLeft, setTimeLeft] = useState(null);
const [showConfirmFinish, setShowConfirmFinish] = useState(false);
const [showQuestionNavigator, setShowQuestionNavigator] =
  useState(false);

const [flaggedQuestions, setFlaggedQuestions] =
  useState({});



// ---------------- REPORT ----------------
const [report, setReport] = useState(null);

/* ============================================================
   LOAD REPORT (ONLY WHEN EXAM IS COMPLETED)
============================================================ */
const loadReport = useCallback(async (attemptId = null) => {
  try {
    console.log("========== loadReport ==========");
    console.log("📌 parentMode:", parentMode);
    console.log("📌 attemptId:", attemptId);
    console.log("📌 studentId:", studentId);

    const isHomework =
      parentMode === "homework" ||
      parentMode === "report_homework";

    console.log("📌 isHomework:", isHomework);

    let url = isHomework
      ? `${API_BASE}/api/student/homework-report/oc-thinking-skills?student_id=${studentId}`
      : `${API_BASE}/api/student/exam-report/oc-thinking-skills?student_id=${studentId}`;

    if (attemptId !== null && attemptId !== undefined) {
      url += `&exam_attempt_id=${attemptId}`;
    }

    console.log("🌐 Report URL:", url);

    const res = await fetch(url);

    console.log("📡 Response status:", res.status);

    if (!res.ok) {
      console.warn("⚠️ Report not available yet");
      setReport(null);
      setMode("report");
      return;
    }

    const data = await res.json();

    console.log("✅ REVIEW API RESPONSE:", data);
    console.log("📊 Report loaded:", data);

    setReport(data);

    if (
      data.exam_attempt_id &&
      examAttemptId !== data.exam_attempt_id
    ) {
      setExamAttemptId(data.exam_attempt_id);
    }

    setMode("report");

    await loadAttempts();

  } catch (err) {
    console.error("❌ loadReport error:", err);
  }
}, [
  studentId,
  parentMode,
  API_BASE,
  examAttemptId,
  loadAttempts
]);
useEffect(() => {
  if (!isReview) return;
  if (!examAttemptId) return;

  setReviewLoading(true);
}, [examAttemptId, isReview]);
useEffect(() => {
  if (isReview) {
    setShowQuestionNavigator(false);
  }
}, [isReview]);

useEffect(() => {
  if (mode !== "exam") return;

  const handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = ""; // 🔥 required for browser to show confirmation
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, [mode]);
 useEffect(() => {
  if (!studentId) return;
  if (mode !== "loading") return;

  // 🟣 REPORT MODE
  if (parentMode?.startsWith("report")) {
    loadReport();
    return;
  }

 

  // 🟢 EXAM MODE handled separately
}, [studentId, parentMode, mode, loadReport]);
useEffect(() => {
  setExplanation(null);
}, [currentIndex]);
useEffect(() => {
  console.log("🔄 MODE CHANGED:", mode);
}, [mode]);

 
useEffect(() => {
  if (mode !== "exam" || questions.length === 0) return;

  window.history.replaceState(
    { questionIndex: 0 },
    "",
    window.location.href
  );

  window.history.pushState(
    { questionIndex: 0 },
    "",
    window.location.href
  );
}, [mode, questions.length]);
 useEffect(() => {
  if (mode !== "exam") return;

  if (isPopNavigationRef.current) {
    isPopNavigationRef.current = false;
    return;
  }

  window.history.pushState(
    { questionIndex: currentIndex },
    "",
    window.location.href
  );
}, [currentIndex, mode]);
 useEffect(() => {
  if (mode !== "exam") return;

  const handlePopState = (e) => {
    const state = e.state;

    // 🔥 CASE 1: On Q1 → block exit
    if (currentIndex === 0) {
      if (!showConfirmFinish) {
        setShowConfirmFinish(true);
      }

      window.history.replaceState(
        { questionIndex: 0 },
        "",
        window.location.href
      );

      return;
    }

    // 🔥 CASE 2: Normal navigation
    if (!state || typeof state.questionIndex !== "number") {
      return;
    }

    isPopNavigationRef.current = true;
    setCurrentIndex(state.questionIndex);
  };

  window.addEventListener("popstate", handlePopState);

  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
}, [mode, currentIndex, showConfirmFinish]);

 // 🔑 only what actually matters
/* ============================================================
   START / RESUME EXAM (SINGLE SOURCE OF TRUTH)
============================================================ */
useEffect(() => {
  if (!studentId) return;
  if (parentMode !== "exam") return;
  if (!parentMode) return;  
  if (hasStartedRef.current) return;   // 🔒 prevent double call

  hasStartedRef.current = true;

  setMode("exam");

  const startExam = async () => {
    const res = await fetch(
      `${API_BASE}/api/student/start-exam-oc-thinking-skills`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id: studentId })
      }
    );

    const data = await res.json();
    // 🔥 ADD THESE LOGS
    console.log("🧪 RAW start-exam response:", data);
    console.log("🧪 QUESTIONS PAYLOAD:", data.questions);
    console.log(
      "🧪 FIRST QUESTION OPTIONS:",
      data.questions?.[0]?.options
    );

    if (data.completed === true) {
      sessionStorage.setItem("oc_thinking_skills_completed", "true");
      await loadReport();
      return;
    }

    setQuestions(data.questions || []);
    setTimeLeft(data.remaining_time);
    onExamStart?.();
  };

  startExam();
}, [studentId, parentMode]);
useEffect(() => {
  if (!studentId) return;
  if (!parentMode) return; 
  if (parentMode !== "homework") return;
  if (hasStartedRef.current) return;

  hasStartedRef.current = true;

  setMode("exam"); // reuse same UI

  const startHomework = async () => {
  const res = await fetch(
    `${API_BASE}/api/student/start-homework-oc-thinking-skills`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ student_id: studentId })
    }
  );

  const data = await res.json();

  console.log("📘 HOMEWORK RESPONSE:", data);

  // 🔥 ADD THIS BLOCK (CRITICAL)
  if (data.completed === true) {
    await loadReport();
    return;
  }

  setQuestions(data.questions || []);
  setTimeLeft(data.remaining_time);
  onExamStart?.();
};

  startHomework();
}, [studentId, parentMode]);
useEffect(() => {
  if (mode !== "exam") {
    hasStartedRef.current = false;
  }
}, [mode]);
/* ============================================================
   FINISH EXAM (SUBMIT ONLY — NO UI DECISIONS)
============================================================ */
const finishExam = useCallback(
async (reason = "submitted") => {
  if (hasSubmittedRef.current) return;
  hasSubmittedRef.current = true;

  const payload = {
    student_id: studentId,
    answers
  };

  try {
    const endpoint =
      parentMode === "homework"
        ? "/api/student/submit-homework-oc-thinking-skills"
        : "/api/student/finish-exam/oc-thinking-skills";

    await fetch(`${API_BASE}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    await loadReport();

    // ✅ notify parent
    onExamFinish?.();

  } catch (err) {
    console.error("❌ finish-exam error:", err);
  }
},
[studentId, answers, loadReport, onExamFinish]
);

/* ============================================================
   TIMER (AUTO SUBMIT)
============================================================ */
useEffect(() => {
  if (mode !== "exam" || timeLeft === null) return;

  if (timeLeft <= 0) {
    setShowConfirmFinish(false); // ✅ force-close modal
    finishExam("time_expired");
    return;
  }

  if (showConfirmFinish) return;

  const interval = setInterval(() => {
    setTimeLeft(t => t - 1);
  }, 1000);

  return () => clearInterval(interval);
}, [timeLeft, mode, showConfirmFinish, finishExam]);
const toggleFlagQuestion = () => {

  const qid =
    activeQuestions[currentIndex]?.q_id;

  if (!qid) return;

  setFlaggedQuestions(prev => ({

    ...prev,

    [qid]: !prev[qid]

  }));
};
/* ============================================================
   ANSWER HANDLING
============================================================ */
const handleAnswer = (optionKey) => {
  console.log("ANSWER CLICKED", optionKey, questions[currentIndex]?.q_id);

  const qid = String(questions[currentIndex]?.q_id);

  if (!qid) return;

  setAnswers(prev => ({
    ...prev,
    [qid]: optionKey.toUpperCase()
  }));
};

const goToQuestion = (idx) => {
  if (idx < 0 || idx >= questions.length) return;

  const qid = String(questions[idx].q_id);


  if (!isReview) {
    setVisited(prev => ({ ...prev, [qid]: true }));
  }

  setCurrentIndex(idx);
};


const formatTime = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${m}:${s}`;
};

/* ============================================================
   RENDER
============================================================ */


const activeQuestions = questions;
const handleReviewLoaded = useCallback((qs) => {
  setQuestions(qs || []);
  setCurrentIndex(0);
  setVisited({});
  setAnswers({});
  setReviewLoading(false);
}, []);

// Only block loading for exam & review
if (mode === "exam" && !questions.length) {
  return <p className="loading">Loading…</p>;
}

if (mode === "loading") {
  return <p className="loading">Loading…</p>;
}

if (mode === "report") {
  return (
    <ThinkingSkillsReport
      report={report}
      attempts={attempts}
      onViewExamDetails={handleViewExamDetails}
      onSelectAttempt={(id) => {
        console.log("📅 selected attempt:", id);
        loadReport(id);
      }}
      onBackToDashboard={onBackToDashboard}
    />

  );
}
// ---------------- EXAM UI ----------------
const currentQ = activeQuestions[currentIndex];
if (!currentQ && !isReview) return null;
console.log("REVIEW QUESTION", currentQ);
const optionEntries = currentQ
  ? Object.entries(
      currentQ.options ||
      currentQ.choices ||
      currentQ.answer_options ||
      {}
    )
  : [];
 
return (
<div
  className={styles.examShell}
  style={{
    height: "100vh",
    overflowY: "auto"
  }}
>
  <div className={styles.examContainer}>
 {isReview && reviewLoading && (
  <OcThinkingSkillsReview
    key={examAttemptId || "latest"}
    studentId={studentId}
    examAttemptId={examAttemptId}
    parentMode={parentMode}
    onLoaded={handleReviewLoaded}
  />
)}
 

    {/* HEADER */}
    <div className="exam-header">

  {!isReview && (
    <div className="timer">
      ⏳ {formatTime(timeLeft)}
    </div>
  )}

  <div className="question-header-center">
    <div className="question-counter-inline">

      <span className="question-counter-text">
        Question {activeQuestions.length ? currentIndex + 1 : 0} of {activeQuestions.length}
      </span>

      <button
        className="question-grid-toggle"
        onClick={() => setShowQuestionNavigator(prev => !prev)}
      >
        ▦
      </button>

      {isReview && (
        <>
          <button
            className="nav-btn finish"
            onClick={() => {
              setMode("report");
              setExplanation(null);
            }}
          >
            Exit Review
          </button>

          <select
            className="review-exam-dropdown"
            value={examAttemptId || ""}
            onChange={(e) => {
              const id = Number(e.target.value);
              setExamAttemptId(id);
              setCurrentIndex(0);
              setQuestions([]);
              setExplanation(null);
            }}
          >
            <option value="">
              Select Attempt
            </option>

            {attempts.map((a) => (
              <option
                key={a.exam_attempt_id}
                value={a.exam_attempt_id}
              >
                {new Date(a.completed_at).toLocaleString()}
              </option>
            ))}
          </select>
        </>
      )}
    </div>
  </div>

  
    <div className="exam-header-actions">
  <div className="header-nav-buttons">
    <button
      className="nav-btn prev"
      onClick={() => goToQuestion(currentIndex - 1)}
      disabled={currentIndex === 0}
    >
      Previous
    </button>

    {!isReview && (
      <button
        className={`flag-btn ${
          flaggedQuestions[activeQuestions[currentIndex]?.q_id]
            ? "flagged"
            : ""
        }`}
        onClick={toggleFlagQuestion}
      >
        🚩{" "}
        {flaggedQuestions[activeQuestions[currentIndex]?.q_id]
          ? "Unflag"
          : "Flag"}
      </button>
    )}

    {isReview ? (
      <button
        className="nav-btn next"
        onClick={() => goToQuestion(currentIndex + 1)}
        disabled={currentIndex === activeQuestions.length - 1}
      >
        Next
      </button>
    ) : currentIndex < activeQuestions.length - 1 ? (
      <button
        className="nav-btn next"
        onClick={() => goToQuestion(currentIndex + 1)}
      >
        Next
      </button>
    ) : (
      <button
        className="nav-btn finish"
        onClick={() => setShowConfirmFinish(true)}
      >
        Finish Exam
      </button>
    )}
  </div>
</div>
  
</div>

    {/* QUESTION INDEX */}
    {showQuestionNavigator && (

        <div className="question-index-wrapper">
        {!isReview && (
          <div className="question-summary-row">

            <div className="summary-item">

              <span className="summary-count">
                {
                  activeQuestions.filter(q =>
                    answers[
                      String(q.q_id)
                    ]
                  ).length
                }
              </span>

              <span className="summary-label">
                Answered
              </span>

            </div>

            <div className="summary-item">

              <span className="summary-count">
                {
                  activeQuestions.length -

                  activeQuestions.filter(q =>
                    answers[
                      String(q.q_id)
                    ]
                  ).length
                }
              </span>

              <span className="summary-label">
                Not answered
              </span>

            </div>

            <div className="summary-item">

              <span className="summary-count">
                {
                  activeQuestions.filter(q =>
                    !visited[
                      String(q.q_id)
                    ]
                  ).length
                }
              </span>

              <span className="summary-label">
                Not read
              </span>

            </div>

            <div className="summary-item">

              <span className="summary-count">
                {
                  Object.values(
                    flaggedQuestions
                  )
                    .filter(Boolean)
                    .length
                }
              </span>

              <span className="summary-label">
                Flagged
              </span>

            </div>

          </div>
        )}

          <div className="question-index-bar">

            {
              activeQuestions.map((q, i) => {

                let cls =
                  "question-index-item";

                if (isReview) {

                  if (
                    !q.student_answer
                  ) {

                    cls += " unanswered";

                  } else if (
                    q.student_answer ===
                    q.correct_answer
                  ) {

                    cls += " correct";

                  } else {

                    cls += " incorrect";
                  }

                } else {

                  const qid =
                    String(q.q_id);

                  if (
                    answers[qid]
                  ) {

                    cls += " answered";

                  } else if (
                    visited[qid]
                  ) {

                    cls += " visited";

                  } else {

                    cls += " unanswered";
                  }
                }

                if (
                  i === currentIndex
                ) {

                  cls += " current";
                }

                return (

                  <button
                    key={q.q_id}

                    className={cls}

                    onClick={() => {

                      goToQuestion(i);

                      setShowQuestionNavigator(
                        false
                      );
                    }}
                  >

                    <div className="question-index-content">

                      <span>
                        {i + 1}
                      </span>

                      {
                        flaggedQuestions[
                          String(q.q_id)
                        ] && (
                          <span className="question-flag">
                            🚩
                          </span>
                        )
                      }

                    </div>

                  </button>
                );
              })
            }

          </div>

        </div>

      )
    }


    {/* QUESTION CARD */}
<div className="question-card">

{/* QUESTION BLOCKS */}
<div className="question-blocks">
{currentQ?.blocks?.map((block, idx) => {
  if (
    block.type === "text" &&
    !block.content?.startsWith("CLASS_YEAR:")
  ) {
    return (
      <p key={idx} className="question-text">
        {block.content}
      </p>
    );
  }

  if (block.type === "image") {
    const cleanSrc = block.src?.trim();
    if (!cleanSrc) return null;
  
    const src = cleanSrc.startsWith("http")
      ? cleanSrc
      : IMAGE_BASE + cleanSrc;
  
    return (
      <img
        key={idx}
        src={src}
        alt={`Question visual ${idx + 1}`}
        className="question-image"
        loading="lazy"
      />
    );
  }



  return null;
})}
</div>

{/* OPTIONS */}
{/* OPTIONS */}
<div className="options-container">

  {optionEntries.map(([optionKey, rawValue]) => {
   console.log("----------- OPTION DEBUG -----------");
  console.log("KEY:", optionKey);
  console.log("RAW VALUE:", rawValue);
  console.log("TYPE OF RAW:", typeof rawValue);

  const optionValue = normalizeOption(rawValue);

  console.log("NORMALIZED:", optionValue);
  console.log("-----------------------------------");

    

    const studentAnswer = isReview
      ? currentQ.student_answer
      : answers[String(currentQ.q_id)];

    const correctAnswer = isReview
      ? currentQ.correct_answer
      : null;

    let optionClass = "option-btn";

    if (isReview) {
      // review mode styling
      if (optionKey === correctAnswer) {
        optionClass += " correct";
      }
      else if (
        studentAnswer &&
        optionKey === studentAnswer &&
        studentAnswer !== correctAnswer
      ) {
        optionClass += " incorrect";
      }
    } 
    else {
      // exam mode styling
      if (studentAnswer === optionKey) {
        optionClass += " selected";
      }
    }

    return (
      <button
        key={optionKey}
        className={optionClass + (isReview ? " review" : "")}
        onClick={() => !isReview && handleAnswer(optionKey)}
      >
        <strong>{optionKey})</strong>

        {optionValue.type === "text" && (
          <span className="option-text">
            {optionValue.content}
          </span>
        )}

        {optionValue?.type === "image" && (
          <>
            {console.log("IMAGE TAG RENDERING:", optionValue.src)}
            <img
              src={optionValue.src}
              alt={`Option ${optionKey}`}
              className="option-image"
              onError={() => console.log("IMAGE FAILED:", optionValue.src)}
              onLoad={() => console.log("IMAGE LOADED:", optionValue.src)}
            />
          </>
        )}
             
      </button>
    );

  })}

</div>


</div>
{/* AI EXPLANATION BUTTON */}
{/* AI EXPLANATION SECTION */}
{isReview && (
  <div className="ai-explanation-section">

    <button
      className="generate-explanation-btn"
      onClick={handleGenerateExplanation}
      disabled={loadingExplanation}
    >
      {loadingExplanation ? "Generating Explanation..." : "✨ Generate AI Explanation"}
    </button>

    {explanation && (
      <div className="ai-explanation-box">
        <h4>AI Explanation</h4>
        <div
         dangerouslySetInnerHTML={{
           __html: formatExplanation(explanation)
         }}
       />
      </div>
    )}

  </div>
)}



    

  </div>
  {showConfirmFinish && (
  <div className="confirm-overlay">
    <div className="confirm-modal">
      <h3>Finish Exam?</h3>
      <p>
        Are you sure you want to submit your exam?
      </p>

      <div className="confirm-actions">
        <button
          className="btn cancel"
          onClick={() => setShowConfirmFinish(false)}
        >
          Cancel
        </button>

        <button
          className="btn confirm"
          onClick={() => {
            setShowConfirmFinish(false);
            finishExam("manual_submit");
          }}
        >
          Submit Exam
        </button>
      </div>
    </div>
  </div>
)}


</div>
);

}

/* ============================================================
 REPORT COMPONENT
============================================================ */
function ThinkingSkillsReport({
  report,
  attempts,
  onViewExamDetails,
  onSelectAttempt,
  onBackToDashboard
}) {
const [selectedAttempt, setSelectedAttempt] = useState("");
if (!report?.overall) {
  return (
    <div
      className="empty-state"
      style={{
        position: "fixed",
        inset: 0,
        overflowY: "auto",
        background: "#f3f4f6",
        padding: "32px",
        boxSizing: "border-box",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <button
        className="back-dashboard-button"
        onClick={onBackToDashboard}
        style={{
          padding: "10px 18px",
          background: "#0d8ecf",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "600",
          marginBottom: "10px",
        }}
      >
        ← Back
      </button>

      <h3>No reports available yet</h3>

      <p>
        You haven’t attempted any exams yet.
        <br />
        Complete an exam to see your performance here.
      </p>
    </div>
  );
}

const {
  overall,
  topic_wise_performance,
  topic_accuracy,
  improvement_areas
} = report;

return (
  <div
    style={{
      position: "fixed",
      inset: 0,
      overflowY: "auto",
      background: "#f3f4f6",
      padding: "32px",
      boxSizing: "border-box",
      zIndex: 1
    }}
  >

    {/* ===============================
       HEADER (Overall Result – B)
    =============================== */}
    <div style={{ marginBottom: "20px" }}>
      <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px"
  }}
>
  <button
    onClick={onBackToDashboard}
    style={{
      padding: "10px 18px",
      background: "#0d8ecf",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: "600"
    }}
  >
    ← Back to Dashboard
  </button>
</div>

  <h2 className="report-title">
    You scored {overall.correct} out of {overall.total_questions} in 
    OC Thinking Skills Test
  </h2>

  {/* 🔽 DATE DROPDOWN */}
  <div style={{ marginTop: "12px" }}>
    <select
      value={selectedAttempt}
      onChange={(e) => {
  const id = Number(e.target.value);
       console.log("🔥 DROPDOWN CHANGED:", id);
  setSelectedAttempt(id);
  onSelectAttempt(id);   // 🔥 THIS triggers loadReport(id)
}}
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        fontSize: "14px"
      }}
    >
      <option value="">Select Attempt</option>

      {attempts.map((a) => (
        <option key={a.exam_attempt_id} value={a.exam_attempt_id}>
          {new Date(a.completed_at).toLocaleString()}
        </option>
      ))}
    </select>
  </div>

  <button
    className="view-exam-btn"
    onClick={onViewExamDetails}
    style={{ marginTop: "12px" }}
  >
    View Exam Details
  </button>

</div>



    <div className="report-grid">

      {/* ===============================
        OVERALL ACCURACY (B)
    =============================== */}
    <div className="report-card">
      <h3>Overall Score</h3>
    
      {(() => {
        const accuracy = Math.round(
          (overall.correct / overall.total_questions) * 100
        );

    
        const donutBackground =
          accuracy === 0
            ? "#e5e7eb" // full grey when no correct answers
            : `conic-gradient(
                #22c55e ${accuracy * 3.6}deg,
                #e5e7eb 0deg
              )`;
    
        return (
          <div className="donut-wrapper">
            <div
              className="donut"
              style={{ background: donutBackground }}
            >
              <span className="donut-text">
                {accuracy}%
              </span>
            </div>
          </div>
        );
      })()}
    
      <div className="stats">
        <p>Total Questions: {overall.total_questions}</p>
        <p>Attempted: {overall.attempted}</p>
        <p>Correct: {overall.correct}</p>
        <p>Incorrect: {overall.incorrect}</p>
        <p>Not Attempted: {overall.not_attempted}</p>
        <p>Accuracy: {overall.score_percent}%</p>
      </div>
    </div>


      {/* ===============================
         TOPIC-WISE PERFORMANCE (A)
      =============================== */}
      <div className="topic-performance-card">
        <h3>Topic-wise Performance</h3>
      
        {topic_wise_performance.map(t => (
          <div key={t.topic} className="topic-row">
            <div className="topic-title">{t.topic}</div>
      
            <div className="stack-bar">
              <div
                className="stack correct"
                style={{ width: `${(t.correct / t.total) * 100}%` }}
              />
              <div
                className="stack incorrect"
                style={{ width: `${(t.incorrect / t.total) * 100}%` }}
              />
              <div
                className="stack not-attempted"
                style={{ width: `${(t.not_attempted / t.total) * 100}%` }}
              />
            </div>
      
            <div className="topic-metrics">
              <span>Attempted: {t.attempted}</span>
              <span className="correct">Correct: {t.correct}</span>
              <span className="incorrect">Incorrect: {t.incorrect}</span>
              <span className="not-attempted">
                Not Attempted: {t.not_attempted}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* ===============================
         IMPROVEMENT AREAS (D)
      =============================== */}
      <div className="report-card">
        <h3>Improvement Areas</h3>

        {improvement_areas.map(t => (
          <div key={t.topic} className="topic-bar">
            <span>{t.topic}</span>

            <div className="bar">
              <div
                className="bar-fill"
                style={{ width: `${t.accuracy_percent}%` }}
              />
            </div>

            <span>{t.accuracy_percent}%</span>

            {t.limited_data && (
              <small className="warning">Limited data</small>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>
);
}
